import React, { useEffect, useState } from "react";
import { Button, Typography } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import no_notification from "../../User/assets/no-notification.svg";
import instance from "../../Utils/api";

const Mynotifications = () => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    const getPayments = async () => {
      try {
        const response = await instance.get("/Payment/getPayments");
        setPayments(response?.data?.data);
      } catch (err) {
        console.log(err);
      }
    };

    getPayments();
  }, []);

  return (
    <React.Fragment>
      <section className="mycart">
        <div className="mycart-title">
          <Button >
            <KeyboardBackspaceIcon />
            Back
          </Button>
          <Typography variant="h4">My Payments</Typography>
        </div>
        <React.Fragment>
          {payments.length === 0 ? (
            <React.Fragment>
              <div className="cart-no-items">
                <img src={no_notification} alt="no_notification" />
                <Typography>No Payments Yet!!</Typography>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <>
                <div className="payments-container">
                  {payments.map((payment, index) => (
                    <div key={index} className="my-notifications">
                      <div className="notifications-details">
                        <Typography variant="h5">For {payment?.for} <span style={{ color: payment?.status === 'Pending' ? '#AA5B00' : payment?.status === 'Done' ? '#38A06C' : '#D1293D', backgroundColor: payment?.status === 'Pending' ? '#FCF2E6' : payment?.status === 'Done' ? '#E1FCEF' : '#FFEDEF', padding: '8px', fontSize: '14px', borderRadius: '4px' }}>{payment?.status}</span></Typography>
                        <Typography>{payment?.payment?.description}</Typography>
                        <Typography variant="h6">Amount: <strong>₹{payment?.amount}</strong></Typography>
                      </div>
                      <div className="notifications-date">
                        <Typography variant="h6">Payment Date:
                          <strong>
                            {payment?.createdAt
                              ? new Date(payment.createdAt).toLocaleDateString("en-GB")
                              : "---"}
                          </strong>
                        </Typography>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            </React.Fragment>
          )}
        </React.Fragment>
      </section>
    </React.Fragment>
  );
};

export default Mynotifications;
